module.exports = __webpack_public_path__ + "img/api.2877c4d4.jpg";